import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../firebase/auth.firebase";

export const addLog = async (action_type, detail) => {
    if (!auth.currentUser) return;
    const user = auth.currentUser;
    const logRef = collection(db, "logs");

    try {
        await addDoc(logRef, {
            timestamp: serverTimestamp(),
            user_id: user.uid,
            user_email: user.email,
            action_type: action_type,
            ...detail
        });
    } catch (error) {
        console.error("Error adding log:", error);
    }
}